var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-data-view-card-list.ts
import { customElement } from "lit/decorators.js";
import { XDataViewAbstractView } from "./x-data-view-abstract-view.js";
var XDataViewCardList = class extends XDataViewAbstractView {
  render() {
    return "todo";
  }
  // protected renderMobileView() {
  //   return xComponents(html`
  //     <x-flex space="sm">
  //       ${this.data.length
  //         ? html`
  //             ${repeat(
  //               this.data,
  //               entityInstance => this.resolveID(entityInstance) + this.options?.finalColumns?.length.toString(),
  //               (entityInstance, index) =>
  //                 html`
  //                   ${virtualize(
  //                     xComponents(this.renderMobileCard(entityInstance)),
  //                     oldHeight => html` <div ${css({ height: `${oldHeight}px`, gridColumn: '1 / -1' })}></div> `,
  //                     {
  //                       wrapperElem: () => this.virtualizationWrapper(entityInstance, index, false),
  //                       onRender: () => {
  //                         this.dispatchEvent(new CustomEvent('virtualization-on-render', { detail: { value: index } }));
  //                       },
  //                     },
  //                   )}
  //                 `,
  //             )}
  //           `
  //         : this.options?.isLoading
  //         ? nothing
  //         : this.options?.emptyState?.()}
  //       ${!this.options?.isPaginationComplete
  //         ? html`
  //             <x-flex center crossaxis-center ${css({ gridColumn: '1 / -1' })} padding="md">
  //               ${this.options?.loader?.()}
  //             </x-flex>
  //           `
  //         : nothing}
  //     </x-flex>
  //   `);
  // }
  // protected renderMobileCard(entityInstance: T['prototype']) {
  //   return html`
  //     <x-flex space="sm">
  //       ${repeat(
  //         this.options?.finalColumns ?? [],
  //         colDef => colDef,
  //         colDef => xComponents(this._showMobileField(entityInstance, colDef)),
  //       )}
  //     </x-flex>
  //     <x-hr></x-hr>
  //   `;
  // }
  // /**
  //  * @param entityInstance The entity to be rendered
  //  * @param colDef The columndefinition of the particular field (determines how it will be rendered)
  //  * @returns a renderable of the field
  //  */
  // protected _showMobileField(entityInstance: T['prototype'], colDef: ColumnDefinition<T>): TemplateResult<1> {
  //   const header = colDef.renderHeader
  //     ? colDef.renderHeader(this)
  //     : colDef.columnName
  //     ? html` <x-text center bold> ${colDef.columnName} </x-text> `
  //     : null;
  //   const body = colDef.renderItem
  //     ? colDef.renderItem(entityInstance, this)
  //     : this.fallbackRenderItem(getFieldFromEntity(entityInstance, colDef));
  //   return html`
  //     <x-flex space="xs" space-between horizontal wrap>
  //       ${header ? html`<x-flex center> ${header} </x-flex>` : nothing}
  //       <x-flex center> ${body} </x-flex>
  //     </x-flex>
  //   `;
  // }
};
XDataViewCardList = __decorateClass([
  customElement("x-data-view-card-list")
], XDataViewCardList);
export {
  XDataViewCardList
};
